import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ShoplistService {
    /**
     * last shop page loaded
     */
    private lastShopPageLoaded: number = 1;

    /**
     * id of the last shop item visited
     */
    private lastShopItemVisitedId: number | null = null;

    /**
     * constructor
     */
    constructor() { }

    /**
     * get the last shop page loaded
     */
    public getLastShopPageLoaded(): number {
        return this.lastShopPageLoaded;
    }

    /**
     * set the last shop page loaded
     */
    public setLastShopPageLoaded(lastLoaded: number): void {
        this.lastShopPageLoaded = lastLoaded;
    }

    /**
     * get the last shop item visited
     */
    public getLastShopItemVisitedId(): number | null {
        return this.lastShopItemVisitedId;
    }

    /**
     * set the last shop item visited
     */
    public setLastShopItemVisitedId(lastVisited: number): void {
        this.lastShopItemVisitedId = lastVisited;
    }
}
